import { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { locale } from 'primereact/api';
import { MarsinetContext } from '../../context/marsinetProvider';
import { Dialog } from 'primereact/dialog';

export interface ILanguage {
  code: string;
  name: string;
  flag: string;
}

interface LanguageChangeEvent {
  value: string;
}

export const LANGUAGES: ILanguage[] = [
  {
    code: 'es',
    name: 'Español',
    flag: '/assets/spanish.svg',
  },
  {
    code: 'en',
    name: 'English',
    flag: '/assets/english.svg',
  },
];
/* eslint-disable-next-line */
export interface SelectorLanguageComponentProps {}

export function SelectorLanguageComponent() {
  // Contexto de idioma
  const { languageContext, setLanguageContext } = useContext(MarsinetContext);

  // Traducciones
  const { t, i18n } = useTranslation();

  // Idioma Seleccionado
  const [selectedLanguage, setSelectedLanguage] = useState<string>(
    LANGUAGES.find((language) => language.code === languageContext)?.code
  );
  const [visible, setVisible] = useState(false);

  // Cambio de idioma
  const handleChangeLanguage = (e: LanguageChangeEvent) => {
    if (!e || !e.value) return;
    setSelectedLanguage(e.value);
    i18n.changeLanguage(e.value);
    setLanguageContext(e.value);
    localStorage.setItem('ln', e.value);
    locale(e.value);
  };

  useEffect(() => {
    setSelectedLanguage(
      LANGUAGES.find((language) => language.code === languageContext)?.code
    );
  }, [languageContext]);

  return (
    <div className="flex items-center justify-center mt-2">
      <img
        src={
          LANGUAGES.find((language) => language.code === selectedLanguage)?.flag
        }
        className="rounded-full object-cover pb-2 mr-2"
        style={{
          width: '23px',
          height: '23px',
        }}
        alt="Bandera de idioma"
        loading="lazy"
      />
      <span className="ml-2 font-medium " onClick={() => setVisible(true)}>
        {t('pages.menu.language')}
      </span>
      <Dialog
        header={t('pages.menu.language')}
        visible={visible}
        onHide={() => setVisible(false)}
        style={{ width: '50vw' }}
        breakpoints={{ '960px': '75vw', '641px': '100vw' }}
      >
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
          {LANGUAGES.map((language) => (
            <div
              key={language.code}
              className={`flex items-center justify-between p-3 rounded-lg cursor-pointer transition-all border text-center ${
                language.code === selectedLanguage
                  ? 'bg-blue-500 text-white border-blue-500 mt-2'
                  : 'bg-white text-black border-gray-300 hover:bg-gray-100 mt-2'
              } `}
              onClick={() => handleChangeLanguage({ value: language.code })}
              style={{
                height: '60px',
                width: '100%',
                maxWidth: '200px',
                boxSizing: 'border-box',
              }}
            >
              <div className="flex items-end gap-2">
                <img
                  src={language.flag}
                  loading="lazy"
                  className="rounded-full object-cover"
                  style={{
                    width: '25px',
                    height: '20px',
                  }}
                  alt={`Bandera de ${language.name}`}
                />
                <span className="ml-3 text-medium font-medium flex-1 mt-1">
                  {language.name}
                </span>
              </div>
              {/* Reducir el tamaño de la fuente */}
              {language.code === selectedLanguage && (
                <div className="flex items-center">
                  <span className="ml-4 pi pi-check text-lg " />
                </div>
              )}
            </div>
          ))}
        </div>
      </Dialog>
    </div>
  );
}

export default SelectorLanguageComponent;
